import logLevelTypes from "../../consts/logLevelTypes";

export default {
    [logLevelTypes.INFO]: { enabled: false, method: console.info },
    [logLevelTypes.TRACE]: { enabled: false, method: console.trace },
    [logLevelTypes.WARNING]: { enabled: false, method: console.warn },
    [logLevelTypes.DEBUG]: { enabled: false, method: console.debug },
    [logLevelTypes.ERROR]: { enabled: true, method: console.error }
};